import { ReactNode } from 'react';

export enum RequiredFieldsLocation {
  fields = 'fields',
  payment_method_options = 'payment_method_options',
  payment_options = 'payment_options'
}

export enum RequiredFieldsType {
  payment = 'payment',
  payout = 'payout'
}

export interface IFieldMetadata {
  name: string;
  description: string;
  is_required: boolean;
  regex: string;
  type: string;
  location?: RequiredFieldsLocation;
  format?: string;
  tooltip?: (fieldName: string) => ReactNode | string;
  required_fields?: IFieldMetadata;
  hasCondition?: boolean;
  max_length?: number;
  disabled?: boolean;
}

export interface IRequiredFieldsData {
  fields: Record<string, IFieldMetadata>;
  paymentMethodOptions?: Record<string, IFieldMetadata>;
  customerRequiredFields?: Record<string, any>;
}
